import {Stack, Typography} from "@mui/material";
import {Swiper} from "swiper/react";
import 'swiper/css';
import 'swiper/css/navigation';
import {ReactNode} from "react";
import {useAppSelector} from "../app/store/hooks.ts";
import {isMobileChecker} from "../utils/IsMobileChecker.ts";


interface ICarouselWidgetProps {
    title: string
    titleType: 'title' | 'subTitle'
    height?: string
    perSlide?: number
    autoPlay?: boolean
    children: ReactNode
}

export const CarouselWidget = ({title, titleType, height, perSlide, autoPlay, children}: ICarouselWidgetProps) => {
    const platform = useAppSelector((state) => state.app.platform) || 'unknown';
    const titleVar =  titleType === 'title' ?  'h2' : 'h3'
    const isMobile = isMobileChecker(platform)
    console.log(isMobile)

    return (
        <Stack direction={'column'} spacing={2} padding={'0 8px'} >
            <Typography variant={titleVar} color={'white'} ml={'16px'} sx={{opacity: 0.85}}>
                {title}
            </Typography>
                <Swiper
                    slidesPerView={perSlide || "auto"}
                    spaceBetween={5}
                    cssMode={isMobile ? true : false}
                    autoplay={autoPlay}
                    direction={'horizontal'}
                    style={{
                        height: height || 'auto',
                        width: '100%',
                    }}
                >
                    {children}
                </Swiper>
        </Stack>
    )
};
